export enum StorageType {
  LOCAL,
  SESSION,
  NONE,
}

export type AuthCallBack = () => void;
